import styled from '@emotion/styled'
import { DisplayExport, Todo, WorkItemAction, workItemTitle } from "@fusion-advantage/formlib"
import { V2L2WorkItemDetailActions, V2L2WorkItemDetailContent, V2L2WorkItemDetailRoot, V2L2WorkItemDetailTitle } from "./V2L2WorkItemDetail"
import { V2L2WorkItemDetailContentItem, V2L2WorkItemDetailGuidContentItem } from "./V2L2WorkItemDetailContentItem"
import { L1ReasonableButton } from "../../../form/l1/L1Button"
import { FusionColor } from "../../../../theme/FusionStyle"
import { faBan, faCircleCheck, faCloudArrowUp, faGlasses } from '@fortawesome/pro-regular-svg-icons'
import { faPlay } from '@fortawesome/pro-solid-svg-icons'
import { V2L2WorkItemBranchDesignator } from './V2L2WorkItemBranchDesignator'

const Spacer = styled.div({ flex: 1 })

interface V2L3TodoReadyDetailProps {
	todo: Todo
	dexp: DisplayExport
	pendingSync: boolean
	canViewForm: boolean
	canContinueForm: boolean
	canCancel: boolean
	onActionClick: (action: WorkItemAction) => void
}

export const V2L3TodoReadyDetail = ({
	todo,
	dexp,
	pendingSync,
	canViewForm,
	canContinueForm,
	canCancel,
	onActionClick,
}: V2L3TodoReadyDetailProps) => {
	return (
		<V2L2WorkItemDetailRoot>
			<V2L2WorkItemDetailTitle ready={true}>
				{workItemTitle(todo)}
				<Spacer />
				<V2L2WorkItemBranchDesignator designator={dexp.branchDesignator} />
			</V2L2WorkItemDetailTitle>
			<V2L2WorkItemDetailContent>
				<V2L2WorkItemDetailContentItem label="Date of Service">
					{dexp.dateOfService ?? '—'}
				</V2L2WorkItemDetailContentItem>
				<V2L2WorkItemDetailContentItem label="Client" span={2}>
					{dexp.clientName ?? '—'}
				</V2L2WorkItemDetailContentItem>
				<V2L2WorkItemDetailGuidContentItem label="Encounter GUID" value={dexp.encounterGuid} />
				<V2L2WorkItemDetailContentItem label="Encounter Status">
					{dexp.codeNext}
				</V2L2WorkItemDetailContentItem>
				<V2L2WorkItemDetailGuidContentItem label="Branch GUID" value={dexp.branchGuid} />
				{pendingSync ? (
					<V2L2WorkItemDetailContentItem label="Cloud Sync Status" icon={faCloudArrowUp}>
						Pending
					</V2L2WorkItemDetailContentItem>
				) : (
					<V2L2WorkItemDetailContentItem label="Cloud Sync Status" icon={faCircleCheck}>
						In Sync
					</V2L2WorkItemDetailContentItem>
				)}
				<V2L2WorkItemDetailContentItem label="Last Saved Time">
					{dexp.lastUpdateDt ?? '—'}
				</V2L2WorkItemDetailContentItem>
			</V2L2WorkItemDetailContent>
			<V2L2WorkItemDetailActions>
				{canViewForm ? (
					<L1ReasonableButton
						color={FusionColor.White}
						icon={faGlasses}
						label="View Form"
						onClick={() => onActionClick(WorkItemAction.ViewForm)}
					/>
				) : null}
				{canContinueForm ? (
					<L1ReasonableButton
						icon={faPlay}
						label="Continue Form"
						onClick={() => onActionClick(WorkItemAction.ContinueForm)}
					/>
				) : null}
				<Spacer />
				{canCancel ? (
					<L1ReasonableButton
						color={FusionColor.StopRed}
						icon={faBan}
						label="Cancel"
						onClick={() => onActionClick(WorkItemAction.CancelAppointment)}
					/>
				) : null}
			</V2L2WorkItemDetailActions>
		</V2L2WorkItemDetailRoot>
	)
}
